import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import SlideShow from './slideshow/SlideShow';
import NavThumbnails from './navigationThumbnails/NavThumbnails';
import { setSlideshowBasedOnQuerystring } from '../actions';
import SoundPlayer from './SoundPlayer';

class Home extends React.Component {

    //after npm i query-string
    //http://localhost:3000/?token=1
    //I need to determine which slide show to show based on a query string value
    componentDidMount() {
        //const url = new URL(window.location.href);
        //url.searchParams.set('token', '1');
        // window.history.pushState(null, '', url);
        const value = queryString.parse(this.props.location.search);
        const token = value.token;
        //console.log('token ', token)//123chris
        this.props.setSlideshowBasedOnQuerystring(token);
    }


    render() {
        return (
            <div className="home-page-container">
                <div align="center">
                    <button className="controls" id="previous">Previous</button>
                    <button className="controls" id="pause">Pause</button>
                    <button className="controls" id="next">Next</button>
                </div>
                <div align="center">
                    <button className="controls" id="restart">Start at beginning</button>
                    <SoundPlayer></SoundPlayer>
                </div>
                <div align="center">
                    <SlideShow />
                    <NavThumbnails />
                </div>
            </div >
        );
    };
}
const mapStateToProps = (state) => {
    return {
      
    };
}
//NOTE action creator(s) included here
export default connect(mapStateToProps, { setSlideshowBasedOnQuerystring: setSlideshowBasedOnQuerystring })(Home);

